<script type="text/jsx">
    export default {
        computed: {
            ccmOptions: function () {
                return this.campaign.options || {};
            },
            isGiftCertAllowed: function () {
                return this.ccmOptions.is_giftcert_allowed || false;
            },
            isPromoCodeAllowed: function () {
                return this.ccmOptions.is_promocode_allowed || false;
            },
            isGreekCharactersAllowed: function () {
                return this.ccmOptions.is_greek_characters_allowed || false;
            },
            isInscriptionAllowed: function () {
                return this.ccmOptions.is_inscription_allowed || false;
            },
            isInscriptionAllUppercase: function () {
                var inscription = this.ccmOptions.inscription || {};
                if ('is_all_uppercase' in inscription && inscription.is_all_uppercase === false) {
                    // expected to be explicitly set to false
                    return false;
                }
                return true;
            },
            isConvenienceFeeAllowed: function () {
                var convenience = this.ccmOptions.convenience || {};
                return true; // convenience.is_allowed || false; // always allowed for OOS
            },
            isLocationPreferenceAllowed: function () {
                return this.ccmOptions.is_locationpreference_allowed || false;
            },
            isMultiLogoAllowed: function () {
                return this.ccmOptions.is_multilogo_allowed || false;
            },
            isDonationAllowed: function () {
                return this.ccmOptions.is_donation_allowed || false;
            },
            convenienceFee: function () {
                var convenience = this.ccmOptions.convenience || {};
                return +(convenience.fee || 0);
            },
            taxRate: function () {
                var tax = this.ccmOptions.tax || {};
                return +(tax.rate || 0);
            },
            isDynamicTaxing: function () {
                var tax = this.ccmOptions.tax || {};
                if ('type' in tax && tax.type == 'dynamic') {
                    return true;
                }
                return false;
            },
            isInFramePayments: function () {
                var pp = this.ccmOptions.payment_processing || {};
                return ('api_username' in pp) ? true : false;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// campaign-configuration.vue?003076d8